import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Objective from './view/objective';
import ObjectiveView from './form/objective-view';

const ObjectiveRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Objective />} />
    <Route path=":id">
      <Route index element={<ObjectiveView />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ObjectiveRoutes;
